export enum MODULE_MODE {
  EDIT = "EDIT",
  PUBLISHED = "PUBLISHED",
}
